export default __webpack_public_path__ + "3cd647b80dc055c1a12fb4cff2c11514.svg";